import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "@root/store";
import { playListItem } from "./actions";
import { selectCsoundStatus } from "@comp/csound/selectors";
import { pauseCsound, resumePausedCsound } from "@comp/csound/actions";
import { selectCurrentlyPlayingProject } from "./selectors";
import AlertIcon from "@mui/icons-material/ErrorOutline";
import { useTheme } from "@emotion/react";
import ProjectAvatar from "@elem/project-avatar";
import * as SS from "./styles";
import { jsx as ___EmotionJSX } from "@emotion/react";
var SvgPlayIcon = function SvgPlayIcon(_ref) {
    var shouldDisplay = _ref.shouldDisplay, theme = _ref.theme;
    return ___EmotionJSX("svg", {
        x: 0,
        y: 0,
        className: "listPlayIcon",
        style: {
            width: "calc(100% - 24px)",
            height: "calc(100% - 24px)",
            position: "absolute",
            right: 12,
            fill: theme.allowed,
            display: shouldDisplay ? "inherit" : "none"
        },
        enableBackground: "new 0 0 58.752 58.752",
        viewBox: "0 0 58.752 58.752",
        xmlSpace: "preserve"
    }, ___EmotionJSX("path", {
        d: "M52.524 23.925L12.507.824c-1.907-1.1-4.376-1.097-6.276 0a6.294 6.294 0 00-3.143 5.44v46.205a6.29 6.29 0 003.131 5.435 6.263 6.263 0 006.29.005l40.017-23.103a6.3 6.3 0 003.138-5.439 6.315 6.315 0 00-3.14-5.442zm-3 5.687L9.504 52.716a.27.27 0 01-.279-.005.28.28 0 01-.137-.242V6.263a.28.28 0 01.421-.243l40.01 23.098a.29.29 0 01.145.249.283.283 0 01-.14.245z"
    }));
};
var ListPlayButton = function ListPlayButton(_ref2) {
    var project = _ref2.project;
    var theme = useTheme();
    var currentlyPlayingProject = useSelector(selectCurrentlyPlayingProject);
    var csoundStatus = useSelector(selectCsoundStatus);
    var projectUid = project.projectUid, _project$iconBackgrou = project.iconBackgroundColor, iconBackgroundColor = _project$iconBackgrou === void 0 ? "#000" : _project$iconBackgrou;
    var isPlaying = currentlyPlayingProject === projectUid;
    var hasError = isPlaying && csoundStatus === "error";
    var isPaused = isPlaying && csoundStatus === "paused";
    var isStop = csoundStatus === "stopped";
    var _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), isStartingUp = _useState2[0], setIsStartingUp = _useState2[1];
    var dispatch = useDispatch();
    useEffect(function () {
        if (isPlaying && isStartingUp && csoundStatus === "playing" || isPlaying && isStartingUp && csoundStatus === "error") {
            setIsStartingUp(false);
        }
    }, [isPlaying, csoundStatus, currentlyPlayingProject, isStartingUp]);
    var buttonCallback = useCallback(/*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1)
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!isStartingUp) {
                            _context.next = 4;
                            break;
                        }
                        return _context.abrupt("return");
                    case 4:
                        if (!isPlaying) {
                            setIsStartingUp(true);
                        }
                    case 5:
                        isPaused ? dispatch(resumePausedCsound()) : isPlaying && !hasError ? dispatch(pauseCsound()) : dispatch(playListItem({
                            projectUid: projectUid
                        }));
                    case 6:
                    case "end":
                        return _context.stop();
                }
        }, _callee);
    })), [dispatch, hasError, isPaused, isPlaying, isStartingUp, projectUid]);
    var IconComponent = ___EmotionJSX(ProjectAvatar, {
        project: project
    });
    return ___EmotionJSX(SS.StyledAvatar, {
        isPlaying: isPlaying,
        isPaused: isPaused,
        isStop: isStop,
        isStartingUp: isStartingUp,
        hasError: hasError,
        iconBackgroundColorProp: iconBackgroundColor,
        onClick: buttonCallback
    }, ___EmotionJSX(React.Fragment, null, IconComponent, ___EmotionJSX(SvgPlayIcon, {
        shouldDisplay: (isPaused || isStop || !isPlaying) && !isStartingUp && !hasError,
        theme: theme
    }), ___EmotionJSX(AlertIcon, {
        className: "projectIcon",
        style: {
            fill: "white",
            fontSize: 40,
            display: hasError ? "inherit" : "none"
        },
        fontSize: "large",
        color: "error"
    }), ___EmotionJSX("span", {
        css: SS.loadingSpinner,
        style: {
            display: isStartingUp ? "inherit" : "none"
        }
    }, ___EmotionJSX("span", null), ___EmotionJSX("span", null)), ___EmotionJSX("span", {
        style: {
            display: isPlaying && !hasError && !isPaused ? "inherit" : "none"
        },
        css: SS.pauseIcon
    })));
};
export default /*#__PURE__*/ React.memo(ListPlayButton);
